// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zMxsI","largestCol":"styles_largestCol__3Q624","smallestCol":"styles_smallestCol__2nIy4"};